<template>
    <div class="col-xs-12 col-md-4">
        <notifications position="right top"/>
        <div class="thumbnail">
            <!-- Preview Image -->
            <img v-if="item.logo" class="img-fluid rounded" :src="previewLogo" alt="">

            <div class="no-logo">
                <img v-if="!item.logo" class="img-fluid rounded" :src="previewLogo" alt="">
                <h4 v-if="!item.logo">{{ item.title }}</h4>
            </div>

            <div class="caption">
                <router-link :to="{ name: 'user.gyms.view', params: { id: item.id }}"
                             class="nav-link"
                             active-class="active">
                    <div class="col-md-12">
                        <h3>{{ item.title }}</h3>
                    </div>
                </router-link>
                <p>{{ item.description }}</p>

                <router-link :to="{ name: 'catalog.gym.edit', params: {id: item.id} }"
                             class="btn btn-link"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> {{ $t('edit_gym') }}
                </router-link>

                <!--<a href="#" @click.stop="deleteGymClick()" class="btn btn-link">-->
                    <!--<i class="fa fa-trash-o"></i>-->
                <!--</a>-->
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import axios from 'axios';

    export default {
        name: 'SsCatalogItem',

        props: {
            item: {
                type: Object,
                default: () => ({})
            }
        },

        data: () => ({
            errors: []
        }),

        computed: {
            previewLogo () {
                if (this.item && this.item.logo) {
                    return this.item.logo;
                } else {
                    return 'https://hdwallsource.com/img/2014/4/free-background-wallpaper-22918-23554-hd-wallpapers.jpg';
                }
            }
        },

        methods: {
            async deleteGymClick () {
                axios.delete('/api/gyms/' + this.item.id)
                    .then(response => {
                        if (response.data === true) {
                            this.$store.dispatch('deleteGym', this.item);
                            this.$notify({
                                title: '',
                                type: 'success',
                                text: 'Зал був видалений!'
                            });
                        }
                    })
                    .catch(e => {
                        this.errors.push(e);
                    });
            }
        }
    }
</script>

<style scoped>
    .thumbnail {
        border: 1px solid #e6e6e6;
    }

    .thumbnail .caption {
        padding: 5px 10px 0;
    }

    .thumbnail .caption h3 {
        text-align: center;
        padding: 15px 0;
    }

    .no-logo {
        position: relative;
    }

    .no-logo img {
        width: 100%;
    }

    .no-logo h4 {
        position: absolute;
        top: 35%;
        text-align: center;
        width: 100%;
        color: #057aff;
        font-size: 30px;
        text-shadow: 2px 8px 8px rgba(212, 212, 212, 0.5), 2px -6px 25px rgba(0, 0, 0, 1);
    }

    button {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/common/ss_catalog_item.vue